import type {
  CreateExchangeRateInput,
  ExchangeRateListResponse,
  ExchangeRateResponse,
  ListExchangeRatesQuery,
} from '@kora/types';
import { apiRequest } from './client.js';

/**
 * Exchange rates API. Thin typed wrappers around /v1/exchange-rates.
 * Contract lives in apps/api/src/routes/exchange-rates.ts.
 */

export function listExchangeRates(
  args: Partial<ListExchangeRatesQuery> = {},
): Promise<ExchangeRateListResponse> {
  const params = new URLSearchParams();
  if (args.fromCurrency) params.set('fromCurrency', args.fromCurrency);
  if (args.toCurrency) params.set('toCurrency', args.toCurrency);
  if (args.asOf) params.set('asOf', args.asOf);
  if (args.limit) params.set('limit', String(args.limit));
  const qs = params.toString();
  return apiRequest<ExchangeRateListResponse>(
    `/v1/exchange-rates${qs ? `?${qs}` : ''}`,
  );
}

export function createExchangeRate(
  input: CreateExchangeRateInput,
): Promise<ExchangeRateResponse> {
  return apiRequest<ExchangeRateResponse>('/v1/exchange-rates', {
    method: 'POST',
    body: input,
  });
}

export interface SyncFxResponse {
  syncedPairs: number;
  skippedDuplicates: number;
  /** Host of the FX provider (e.g. "open.er-api.com"). Null when there's nothing to sync. */
  provider: string | null;
  /** YYYY-MM-DD the upstream marked as effective. Null when there's nothing to sync. */
  effectiveDate: string | null;
  message: string;
}

export function syncFxRates(): Promise<SyncFxResponse> {
  return apiRequest<SyncFxResponse>('/v1/exchange-rates/sync', { method: 'POST' });
}
